import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

const ProgressCircle = ({ progress = 0 }) => {
  return (
    <Box
      sx={{
        width: 48,
        height: 50,
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        isolation: 'isolate',
      }}
    >
      {/* Background ring */}
      <CircularProgress
        variant="determinate"
        value={100}
        size={32}
        thickness={4}
        sx={{
          position: 'absolute',
          color: 'rgba(82, 138, 192, 0.12)',
        }}
      />
      {/* Foreground progress */}
      <CircularProgress
        variant="determinate"
        value={progress}
        size={32}
        thickness={4}
        sx={{
          position: 'absolute',
          color: '#528AC0',
          transition: 'all 0.3s ease',
        }}
      />
      {/* Percentage text */}
      <Typography
        sx={{
          position: 'absolute',
          fontFamily: 'Lexend, sans-serif',
          fontStyle: 'normal',
          fontWeight: 400,
          fontSize: 8,
          lineHeight: '166%',
          letterSpacing: 0.4,
          color: '#FFFFFF',
          userSelect: 'none',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 21,
          height: 17,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {`${Math.round(progress)}%`}
      </Typography>
    </Box>
  );
};

export default ProgressCircle;
